<dialog id="studentFormModal" class="modal" #modal appPreventEscClose>
    <div class="modal-box relative p-0 w-11/12 max-w-2xl">

        <div class="py-5 relative">

            <div class="flex justify-between items-center px-5">
                <h2 class="text-lg font-semibold capitalize ">{{type == 'edit' ? 'Edit' : 'Create New'}} {{userType}}
                </h2>
                <button class="btn btn-sm btn-circle btn-ghost" (click)="closeModal()"><i
                        class="ri-close-line"></i></button>
            </div>

            <div role="tablist" class="tabs tabs-bordered px-3 capitalize mt-3 hide-scrollbar overflow-x-auto">

                @for (i of tabs; track $index) {
                <button [disabled]="i.isLock || isFetching" role="tab" (click)="currentTab = i.value"
                    class="tab hover:rounded-t-md text-nowrap"
                    [ngClass]="{'tab-active': currentTab == i.value}">{{i.name}}</button>
                }
            </div>

            <div class=" mt-5 py-3 px-7 overflow-y-auto h-[20rem]">

                @defer (when isDataReady) {
                <ng-container [ngSwitch]="currentTab">
                    <!-- personal details -->
                    <form [formGroup]="userPersonalDetailsForm" (ngSubmit)="saveUserDetails()"
                        *ngSwitchCase="'personal'" action="" class="flex flex-col justify-between gap-5 ">
                        <div class=" grid grid-cols-1 md:grid-cols-2 gap-5">

                            <!-- Profile -->
                            <div class=" col-span-1 md:col-span-2">
                                <div class="col-span-1 md:col-span-2 flex items-center gap-2 cursor-pointer"
                                    (click)="file.click()">
                                    <div class="avatar"
                                        [ngClass]="{'ring-zinc-200 ring-offset-base-100 rounded-[1.8rem] ring ring-offset-2':profile_pic != null}">
                                        <div class="mask mask-squircle w-24 bg-zinc-100 border">
                                            <span *ngIf="profile_pic == null"
                                                class="w-full h-full flex flex-col items-center justify-center">
                                                <i class="ri-image-circle-ai-fill text-3xl"></i>
                                                <small class="text-zinc-500">Profile</small>
                                            </span>

                                            <img *ngIf="profile_pic != null" class="w-full h-full object-cover"
                                                src="{{ profile_pic }}" />
                                        </div>
                                    </div>

                                    <div class="ml-3">
                                        <p class="font-semibold">Upload Profile Photo</p>
                                        <p class="text-sm text-gray-500">File size must be under 2MB with 200×230
                                            dimensions.</p>
                                    </div>
                                </div>
                                @if (profilePicError) {
                                <span class="text-red-500 text-xs">{{profilePicError}}</span>
                                }
                                <input type="file" #file class="hidden" id="file" accept="image/*"
                                    (change)="setProfilePic($event)" />
                            </div>
                            <!-- Profile -->
                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">First Name</span>
                                </div>
                                <input type="text" formControlName="first_name" placeholder=""
                                    [ngClass]="{'error': userPersonalDetailsForm.get('first_name')?.invalid && userPersonalDetailsForm.get('first_name')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (userPersonalDetailsForm.get('first_name')?.invalid &&
                                userPersonalDetailsForm.get('first_name')?.touched) {
                                @if (userPersonalDetailsForm.get('first_name')?.hasError('required')) {
                                <span class="text-red-500 text-xs">First name is required.</span>
                                } @else if (userPersonalDetailsForm.get('first_name')?.hasError('trim')) {
                                <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                } @else if (userPersonalDetailsForm.get('first_name')?.hasError('pattern')) {
                                <span class="text-red-500 text-xs">Only alphabets are allowed.</span>
                                } @else if (userPersonalDetailsForm.get('first_name')?.hasError('minlength') || userPersonalDetailsForm.get('first_name')?.hasError('maxlength')) {
                                <span class="text-red-500 text-xs">First name must be between 2 and 50 characters.</span>
                                }
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Last Name</span>
                                </div>
                                <input type="text" formControlName="last_name" placeholder=""
                                    [ngClass]="{'error': userPersonalDetailsForm.get('last_name')?.invalid && userPersonalDetailsForm.get('last_name')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (userPersonalDetailsForm.get('last_name')?.invalid &&
                                userPersonalDetailsForm.get('last_name')?.touched) {
                                @if (userPersonalDetailsForm.get('last_name')?.hasError('required')) {
                                <span class="text-red-500 text-xs">Last name is required.</span>
                                } @else if (userPersonalDetailsForm.get('last_name')?.hasError('trim')) {
                                <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                } @else if (userPersonalDetailsForm.get('last_name')?.hasError('pattern')) {
                                <span class="text-red-500 text-xs">Only alphabets are allowed.</span>
                                } @else if (userPersonalDetailsForm.get('last_name')?.hasError('minlength') || userPersonalDetailsForm.get('last_name')?.hasError('maxlength')) {
                                <span class="text-red-500 text-xs">Last name must be between 2 and 50 characters.</span>
                                }
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Email</span>
                                </div>
                                <input type="email" formControlName="email_id" placeholder=""
                                    [ngClass]="{'error': userPersonalDetailsForm.get('email_id')?.invalid && userPersonalDetailsForm.get('email_id')?.touched}"
                                    class="input input-bordered w-full " maxlength="100" />

                                @if (userPersonalDetailsForm.get('email_id')?.invalid &&
                                userPersonalDetailsForm.get('email_id')?.touched) {
                                @if (userPersonalDetailsForm.get('email_id')?.hasError('required')) {
                                <span class="text-red-500 text-xs">Email ID is required.</span>
                                } @else if (userPersonalDetailsForm.get('email_id')?.hasError('noSpaces')) {
                                <span class="text-red-500 text-xs">Email must not contain spaces.</span>
                                } @else if (userPersonalDetailsForm.get('email_id')?.hasError('pattern')) {
                                <span class="text-red-500 text-xs">Please enter a valid email address.</span>
                                } @else if (userPersonalDetailsForm.get('email_id')?.hasError('maxlength')) {
                                <span class="text-red-500 text-xs">Email ID cannot exceed 100 characters.</span>
                                }
                                }

                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Phone Number</span>
                                </div>
                                <input
                                    formControlName="mobile"
                                    type="tel"
                                    inputmode="numeric"
                                    autocomplete="tel"
                                    placeholder=""
                                    maxlength="10"
                                    [ngClass]="{'error': userPersonalDetailsForm.get('mobile')?.invalid && userPersonalDetailsForm.get('mobile')?.touched}"
                                    class="input input-bordered w-full "
                                    (keypress)="$event.charCode >= 48 && $event.charCode <= 57"
                                     />

                                @if (userPersonalDetailsForm.get('mobile')?.invalid &&
                                userPersonalDetailsForm.get('mobile')?.touched) {
                                @if (userPersonalDetailsForm.get('mobile')?.hasError('required')) {
                                <span class="text-red-500 text-xs">Mobile number is required.</span>
                                } @else if (userPersonalDetailsForm.get('mobile')?.hasError('pattern')) {
                                <span class="text-red-500 text-xs">Mobile number must be exactly 10 digits.</span>
                                }
                                }

                            </label>

                            <div class="input-date ">
                                <label class="form-control col-span-1 w-full ">
                                    <div class="label">
                                    <span class="label-text req">Date of Birth</span>
                                </div>
                                    <input type="date" formControlName="date_of_birth" placeholder="" #dobInput
                                        (focus)="dobInput.click()"
                                        [max]="todayDate"
                                        [ngClass]="{'error': userPersonalDetailsForm.get('date_of_birth')?.invalid && userPersonalDetailsForm.get('date_of_birth')?.touched}"
                                        class="input input-bordered w-full " />
                                </label>
                                @if (userPersonalDetailsForm.get('date_of_birth')?.touched &&
                                userPersonalDetailsForm.get('date_of_birth')?.invalid) {
                                @if (userPersonalDetailsForm.get('date_of_birth')?.hasError('required')) {
                                <span class="text-red-500 text-xs">Date of birth is required.</span>
                                } @else if (userPersonalDetailsForm.get('date_of_birth')?.hasError('pastDate')) {
                                <span class="text-red-500 text-xs">Future dates are not allowed.</span>
                                } @else if (userPersonalDetailsForm.get('date_of_birth')?.hasError('invalidDate')) {
                                <span class="text-red-500 text-xs">Please select a valid date of birth.</span>
                                }
                                }
                            </div>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text">Departments</span>
                                </div>
                                <select formControlName="department_id" class="select select-bordered w-full tf-select-truncate">
                                    <option disabled selected>Choose Department</option>
                                    @for (i of (departments$ | async) || []; track $index) {
                                    <option class="text-base" value="{{i?.id}}">{{i?.department_name}}</option>
                                    }
                                </select>
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text">Education</span>
                                </div>
                                <input type="text" placeholder="" formControlName="education"
                                    class="input input-bordered w-full " 
                                    [ngClass]="{'error': userPersonalDetailsForm.get('education')?.invalid && userPersonalDetailsForm.get('education')?.touched}"/>
                               @if (userPersonalDetailsForm.get('education')?.invalid &&
    userPersonalDetailsForm.get('education')?.touched) {

  @if (userPersonalDetailsForm.get('education')?.hasError('trim')) {
    <span class="text-red-500 text-xs">Please trim extra spaces.</span>
  } @else if (userPersonalDetailsForm.get('education')?.hasError('pattern')) {
    <span class="text-red-500 text-xs">Only alphabets are allowed.</span>
  } @else if (userPersonalDetailsForm.get('education')?.hasError('minlength') ||
              userPersonalDetailsForm.get('education')?.hasError('maxlength')) {
    <span class="text-red-500 text-xs">Education must be between 2 and 100 characters.</span>
  }
}

                                <!-- <select formControlName="education" class="select select-bordered w-full ">
                                    <option disabled selected>Choose Class</option>
                                    <option value="1">option 1</option>
                                    <option value="2">option 2</option>
                                    <option value="3">option 3</option>
                                </select> -->
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text ">Specialization</span>
                                </div>
                                <input type="text" placeholder="" formControlName="specialization"
                                    class="input input-bordered w-full " 
                                    [ngClass]="{'error': userPersonalDetailsForm.get('specialization')?.invalid && userPersonalDetailsForm.get('specialization')?.touched}"/>
                               @if (userPersonalDetailsForm.get('specialization')?.invalid &&
    userPersonalDetailsForm.get('specialization')?.touched) {

  @if (userPersonalDetailsForm.get('specialization')?.hasError('trim')) {
    <span class="text-red-500 text-xs">Please trim extra spaces.</span>
  } @else if (userPersonalDetailsForm.get('specialization')?.hasError('pattern')) {
    <span class="text-red-500 text-xs">Only alphabets are allowed.</span>
  } @else if (userPersonalDetailsForm.get('specialization')?.hasError('minlength') ||
              userPersonalDetailsForm.get('specialization')?.hasError('maxlength')) {
    <span class="text-red-500 text-xs">Specialization must be between 2 and 100 characters.</span>
  }
}
                                
                            </label>

                            @if (type == 'new') {
                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Password</span>
                                </div>
                                <label class="input input-bordered flex items-center gap-2"
                                    [ngClass]="{'error': userPersonalDetailsForm.get('password')?.invalid && userPersonalDetailsForm.get('password')?.touched}">
                                    <input type="{{showPassword ? 'text' : 'password'}}" class="grow w-full"
                                        formControlName="password" placeholder="Password" />
                                    <button type="button" class="btn btn-circle btn-sm"
                                        (click)="showPassword = !showPassword"><i
                                            [ngClass]="{'ri-eye-line': showPassword, 'ri-eye-off-line': !showPassword}"></i></button>
                                </label>
                                @if (userPersonalDetailsForm.get('password')?.invalid &&
                                userPersonalDetailsForm.get('password')?.touched) {
                                @if (userPersonalDetailsForm.get('password')?.hasError('required')) {
                                <span class="text-red-500 text-xs">Password is required.</span>
                                } @else if (userPersonalDetailsForm.get('password')?.hasError('noSpaces')) {
                                <span class="text-red-500 text-xs">Password must not contain spaces.</span>
                                } @else if (userPersonalDetailsForm.get('password')?.hasError('minlength') || userPersonalDetailsForm.get('password')?.hasError('maxlength')) {
                                <span class="text-red-500 text-xs">Password must be between 8 and 20 characters.</span>
                                } @else if (userPersonalDetailsForm.get('password')?.hasError('pattern')) {
                                <span class="text-red-500 text-xs">Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.</span>
                                }
                                }
                            </label>
                            }

                        </div>

                        <div class=" sticky -bottom-3 left-0 flex justify-end bg-white gap-x-3">
                            @if (type == 'edit') {
                            <button type="button" class="btn rounded-full btn-sm px-5" (click)="currentTab='address'"
                                [disabled]="isreqSending">Next</button>
                            }
                            <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isreqSending">
                                @if (isreqSending) {
                                <i class="ri-loader-2-line animate-spin"></i>
                                }@else {
                                <span>Save</span>
                                }
                            </button>
                        </div>
                    </form>
                    <!-- personal details -->
                    <!-- Address Details -->
                    <form [formGroup]="userAddressDetailsForm" (ngSubmit)="saveUserAddressDetails()"
                        *ngSwitchCase="'address'" action="" class="flex flex-col justify-between gap-5 ">

                        <p class="font-semibold underline">Current Address</p>

                        <div class=" grid grid-cols-1 md:grid-cols-2 gap-5" [formGroup]="currentAddress">

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Address</span>
                                </div>
                                <input formControlName="address" type="text" placeholder=""
                                    [ngClass]="{'error': currentAddress.get('address')?.invalid && currentAddress.get('address')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (currentAddress.get('address')?.invalid && currentAddress.get('address')?.touched) {
                                @if (currentAddress.get('address')?.hasError('required')) {
                                <span class="text-red-500 text-xs">Address is required.</span>
                                } @else if (currentAddress.get('address')?.hasError('trim')) {
                                <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                } @else if (currentAddress.get('address')?.hasError('minlength') || currentAddress.get('address')?.hasError('maxlength')) {
                                <span class="text-red-500 text-xs">Address must be between 5 and 255 characters.</span>
                                } @else if (currentAddress.get('address')?.hasError('pattern')) {
                                <span class="text-red-500 text-xs">Please enter a valid address.</span>
                                } @else if (currentAddress.get('address')?.hasError('noSpaces')) {
                                <span class="text-red-500 text-xs">Address cannot contain only spaces.</span>
                                }
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">City</span>
                                </div>
                                <input formControlName="city" type="text" placeholder=""
                                    [ngClass]="{'error': currentAddress.get('city')?.invalid && currentAddress.get('city')?.touched}"
                                    class="input input-bordered w-full " />
                                    @if (currentAddress.get('city')?.invalid && currentAddress.get('city')?.touched) {
                                    @if (currentAddress.get('city')?.hasError('required')) {
                                    <span class="text-red-500 text-xs">City is required.</span>
                                    } @else if (currentAddress.get('city')?.hasError('trim')) {
                                    <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                    } @else if (currentAddress.get('city')?.hasError('pattern')) {
                                    <span class="text-red-500 text-xs">Only alphabets are allowed.</span>
                                    } @else if (currentAddress.get('city')?.hasError('minlength') || currentAddress.get('city')?.hasError('maxlength')) {
                                    <span class="text-red-500 text-xs">City must be between 2 and 50 characters.</span>
                                    }
                                    }
                            </label>

          <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">District</span>
                                </div>
                                <input formControlName="district" type="text" placeholder=""
                                    [ngClass]="{'error': currentAddress.get('district')?.invalid && currentAddress.get('district')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (currentAddress.get('district')?.invalid && currentAddress.get('district')?.touched) {
                                @if (currentAddress.get('district')?.hasError('required')) {
                                <span class="text-red-500 text-xs">District is required.</span>
                                } @else if (currentAddress.get('district')?.hasError('trim')) {
                                <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                } @else if (currentAddress.get('district')?.hasError('pattern')) {
                                <span class="text-red-500 text-xs">Only alphabets are allowed.</span>
                                } @else if (currentAddress.get('district')?.hasError('minlength') || currentAddress.get('district')?.hasError('maxlength')) {
                                <span class="text-red-500 text-xs">District must be between 2 and 50 characters.</span>
                                }
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req ">State</span>
                                </div>
                                <input formControlName="state" type="text" placeholder=""
                                    [ngClass]="{'error': currentAddress.get('state')?.invalid && currentAddress.get('state')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (currentAddress.get('state')?.invalid && currentAddress.get('state')?.touched) {
                                @if (currentAddress.get('state')?.hasError('required')) {
                                <span class="text-red-500 text-xs">State is required.</span>
                                } @else if (currentAddress.get('state')?.hasError('trim')) {
                                <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                } @else if (currentAddress.get('state')?.hasError('pattern')) {
                                <span class="text-red-500 text-xs">Only alphabets are allowed.</span>
                                } @else if (currentAddress.get('state')?.hasError('minlength') || currentAddress.get('state')?.hasError('maxlength')) {
                                <span class="text-red-500 text-xs">State must be between 2 and 50 characters.</span>
                                }
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Pincode</span>
                                </div>
                                <input formControlName="pincode" type="number" min="0" max="999999" placeholder=""
                                    [ngClass]="{'error': currentAddress.get('pincode')?.invalid && currentAddress.get('pincode')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (currentAddress.get('pincode')?.invalid && currentAddress.get('pincode')?.touched) {
                                @if (currentAddress.get('pincode')?.hasError('required')) {
                                <span class="text-red-500 text-xs">Pincode is required.</span>
                                } @else if (currentAddress.get('pincode')?.hasError('pattern')) {
                                <span class="text-red-500 text-xs">Pincode must be exactly 6 digits.</span>
                                }
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Country</span>
                                </div>
                                <input formControlName="country" type="text" placeholder=""
                                    [ngClass]="{'error': currentAddress.get('country')?.invalid && currentAddress.get('country')?.touched}"
                                    class="input input-bordered w-full " />
                                    @if (currentAddress.get('country')?.invalid && currentAddress.get('country')?.touched) {
                                    @if (currentAddress.get('country')?.hasError('required')) {
                                    <span class="text-red-500 text-xs">Country is required.</span>
                                    } @else if (currentAddress.get('country')?.hasError('trim')) {
                                    <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                    } @else if (currentAddress.get('country')?.hasError('pattern')) {
                                    <span class="text-red-500 text-xs">Only alphabets are allowed.</span>
                                    } @else if (currentAddress.get('country')?.hasError('minlength') || currentAddress.get('country')?.hasError('maxlength')) {
                                    <span class="text-red-500 text-xs">Country must be between 2 and 50 characters.</span>
                                    }
                                    }
                            </label>

                        </div>

                        <hr class="my-3">

                        <p class="font-semibold underline">Permanant Address</p>
                        <div class="flex items-center gap-2">
                            <input type="checkbox" class="checkbox checkbox-sm" type="checkbox"
                                formControlName="sameAsCurrent" />
                            <label for="">Use same as current Address</label>
                        </div>

                        <div class=" grid grid-cols-1 md:grid-cols-2 gap-5" [formGroup]="permanentAddress">

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Address</span>
                                </div>
                                <input formControlName="address" type="text" placeholder=""
                                    [ngClass]="{'error': permanentAddress.get('address')?.invalid && permanentAddress.get('address')?.touched}"
                                    class="input input-bordered w-full " />
                                    @if (permanentAddress.get('address')?.invalid &&
                                    permanentAddress.get('address')?.touched) {
                                    @if (permanentAddress.get('address')?.hasError('required')) {
                                    <span class="text-red-500 text-xs">Address is required.</span>
                                    } @else if (permanentAddress.get('address')?.hasError('trim')) {
                                    <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                    } @else if (permanentAddress.get('address')?.hasError('minlength') || permanentAddress.get('address')?.hasError('maxlength')) {
                                    <span class="text-red-500 text-xs">Address must be between 5 and 255 characters.</span>
                                    } @else if (permanentAddress.get('address')?.hasError('pattern')) {
                                    <span class="text-red-500 text-xs">Please enter a valid address.</span>
                                    } @else if (permanentAddress.get('address')?.hasError('noSpaces')) {
                                    <span class="text-red-500 text-xs">Address cannot contain only spaces.</span>
                                    }
                                    }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">City</span>
                                </div>
                                <input formControlName="city" type="text" placeholder=""
                                    [ngClass]="{'error': permanentAddress.get('city')?.invalid && permanentAddress.get('city')?.touched}"
                                    class="input input-bordered w-full " />
                                    @if (permanentAddress.get('city')?.invalid && permanentAddress.get('city')?.touched) {
                                    @if (permanentAddress.get('city')?.hasError('required')) {
                                    <span class="text-red-500 text-xs">City is required.</span>
                                    } @else if (permanentAddress.get('city')?.hasError('trim')) {
                                    <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                    } @else if (permanentAddress.get('city')?.hasError('pattern')) {
                                    <span class="text-red-500 text-xs">Only alphabets are allowed.</span>
                                    } @else if (permanentAddress.get('city')?.hasError('minlength') || permanentAddress.get('city')?.hasError('maxlength')) {
                                    <span class="text-red-500 text-xs">City must be between 2 and 50 characters.</span>
                                    }
                                    }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">District</span>
                                </div>
                                <input formControlName="district" type="text" placeholder=""
                                    [ngClass]="{'error': permanentAddress.get('district')?.invalid && permanentAddress.get('district')?.touched}"
                                    class="input input-bordered w-full " />
                                    @if (permanentAddress.get('district')?.invalid && permanentAddress.get('district')?.touched) {
                                    @if (permanentAddress.get('district')?.hasError('required')) {
                                    <span class="text-red-500 text-xs">District is required.</span>
                                    } @else if (permanentAddress.get('district')?.hasError('trim')) {
                                    <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                    } @else if (permanentAddress.get('district')?.hasError('pattern')) {
                                    <span class="text-red-500 text-xs">Only alphabets are allowed.</span>
                                    } @else if (permanentAddress.get('district')?.hasError('minlength') || permanentAddress.get('district')?.hasError('maxlength')) {
                                    <span class="text-red-500 text-xs">District must be between 2 and 50 characters.</span>
                                    }
                                    }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req ">State</span>
                                </div>
                                <input formControlName="state" type="text" placeholder=""
                                    [ngClass]="{'error': permanentAddress.get('state')?.invalid && permanentAddress.get('state')?.touched}"
                                    class="input input-bordered w-full " />
                                    @if (permanentAddress.get('state')?.invalid && permanentAddress.get('state')?.touched) {
                                    @if (permanentAddress.get('state')?.hasError('required')) {
                                    <span class="text-red-500 text-xs">State is required.</span>
                                    } @else if (permanentAddress.get('state')?.hasError('trim')) {
                                    <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                    } @else if (permanentAddress.get('state')?.hasError('pattern')) {
                                    <span class="text-red-500 text-xs">Only alphabets are allowed.</span>
                                    } @else if (permanentAddress.get('state')?.hasError('minlength') || permanentAddress.get('state')?.hasError('maxlength')) {
                                    <span class="text-red-500 text-xs">State must be between 2 and 50 characters.</span>
                                    }
                                    }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Pincode</span>
                                </div>
                                <input formControlName="pincode" type="number" min="0" max="999999" placeholder=""
                                    [ngClass]="{'error': permanentAddress.get('pincode')?.invalid && permanentAddress.get('pincode')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (permanentAddress.get('pincode')?.invalid && permanentAddress.get('pincode')?.touched) {
                                @if (permanentAddress.get('pincode')?.hasError('required')) {
                                <span class="text-red-500 text-xs">Pincode is required.</span>
                                } @else if (permanentAddress.get('pincode')?.hasError('pattern')) {
                                <span class="text-red-500 text-xs">Pincode must be exactly 6 digits.</span>
                                }
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Country</span>
                                </div>
                                <input formControlName="country" type="text" placeholder=""
                                    [ngClass]="{'error': permanentAddress.get('country')?.invalid && permanentAddress.get('country')?.touched}"
                                    class="input input-bordered w-full " />
                                    @if (permanentAddress.get('country')?.invalid && permanentAddress.get('country')?.touched) {
                                    @if (permanentAddress.get('country')?.hasError('required')) {
                                    <span class="text-red-500 text-xs">Country is required.</span>
                                    } @else if (permanentAddress.get('country')?.hasError('trim')) {
                                    <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                    } @else if (permanentAddress.get('country')?.hasError('pattern')) {
                                    <span class="text-red-500 text-xs">Only alphabets are allowed.</span>
                                    } @else if (permanentAddress.get('country')?.hasError('minlength') || permanentAddress.get('country')?.hasError('maxlength')) {
                                    <span class="text-red-500 text-xs">Country must be between 2 and 50 characters.</span>
                                    }
                                    }
                            </label>

                        </div>

                        <div class="sticky -bottom-3 left-0 flex justify-end items-center bg-white gap-x-3">
                            @if (type == 'edit') {
                            <button type="button" (click)="currentTab = 'personal'" class="btn rounded-full btn-sm px-5"
                                [disabled]="isreqSending">Back</button>
                            <button type="button" (click)="currentTab = 'education'" class="btn rounded-full btn-sm px-5"
                                [disabled]="isreqSending">Next</button>
                            }

                            <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isreqSending">
                                @if (isreqSending) {
                                <i class="ri-loader-2-line animate-spin"></i>
                                }@else {
                                <span>Save</span>
                                }
                            </button>
                        </div>
                    </form>
                    <!-- Address Details -->
                    <!-- education Details -->
                    <form [formGroup]="userEdcuationForm" (ngSubmit)="saveUserEducationDetails()"
                        *ngSwitchCase="'education'">
                        <div formArrayName="educations" class="grid grid-cols-1 divide-y divide-zinc-200 gap-5">
                            @for (education of educationControls; track $index) {
                            <div [formGroupName]="$index" class="grid grid-cols-1 md:grid-cols-2 gap-5 gap-y-2 py-2">
                                <div class="col-span-full flex items-center justify-between">
                                    <div>
                                        <p class="font-semibold underline capitalize">
                                            {{ education.get('education_type')?.value }}</p>
                                        <!-- @if (education.invalid && (education.touched || education.dirty)) {
                                        <span class="text-red-500 text-xs">
                                            {{ education.get('education_type')?.value === 'other' ? 'All Fields are required or Else Remove Section' : 'Complete this section or leave all fields blank' }}
                                        </span>
                                        } -->
                                    </div>
                                    @if (education.get('education_type')?.value === 'other') {
                                    <button type="button" (click)="modifyEducation('remove', $index)"
                                        class="btn btn-sm rounded-full bg-red-100 text-red-500">
                                        <i class="ri-delete-bin-line"></i> Remove
                                    </button>
                                    }
                                </div>

                                <label class="form-control col-span-1 w-full">
                                    <div class="label">
                                        <span class="label-text" [ngClass]="{ 'req': isEducationFieldRequired(education) }">Degree</span>
                                    </div>
                                    <input formControlName="degree" type="text"
                                        [ngClass]="{ 'error': education.get('degree')?.invalid && education.get('degree')?.touched }"
                                        class="input input-bordered w-full" />
                                    @if (education.get('degree')?.invalid && education.get('degree')?.touched) {
                                    @if (education.get('degree')?.hasError('required')) {
                                    <span class="text-red-500 text-xs">Degree is required.</span>
                                    } @else if (education.get('degree')?.hasError('trim')) {
                                    <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                    } @else if (education.get('degree')?.hasError('pattern')) {
                                    <span class="text-red-500 text-xs">Only letters, numbers, spaces, period, hyphen, and ampersand are allowed.</span>
                                    } @else if (education.get('degree')?.hasError('minlength') || education.get('degree')?.hasError('maxlength')) {
                                    <span class="text-red-500 text-xs">Degree must be between 2 and 100 characters.</span>
                                    }
                                    }
                                </label>

                                <label class="form-control col-span-1 w-full">
                                    <div class="label">
                                        <span class="label-text" [ngClass]="{ 'req': isEducationFieldRequired(education) }">Year of Degree</span>
                                    </div>

                                    <select class="select select-bordered" formControlName="year_of_degree"
                                        [ngClass]="{ 'error': education.get('year_of_degree')?.invalid && education.get('year_of_degree')?.touched }">
                                        <option disabled selected>Choose Year</option>
                                        @for (year of years; track $index) {
                                        <option value="{{year}}">{{year}}</option>
                                        }
                                    </select>

                                    @if (education.get('year_of_degree')?.invalid &&
                                    education.get('year_of_degree')?.touched) {
                                    <span class="text-red-500 text-xs">Year of degree is required.</span>
                                    }
                                </label>

                                <label class="form-control col-span-1 md:col-span-2 w-full">
                                    <div class="label">
                                        <span class="label-text" [ngClass]="{ 'req': isEducationFieldRequired(education) }">institute name</span>
                                    </div>
                                    <input formControlName="institute_name" type="text"
                                        [ngClass]="{ 'error': education.get('institute_name')?.invalid && education.get('institute_name')?.touched }"
                                        class="input input-bordered w-full" />
                                    @if (education.get('institute_name')?.invalid &&
                                    education.get('institute_name')?.touched) {
                                    @if (education.get('institute_name')?.hasError('required')) {
                                    <span class="text-red-500 text-xs">Institute name is required.</span>
                                    
                                    } @else if (education.get('institute_name')?.hasError('minlength') || education.get('institute_name')?.hasError('maxlength')) {
                                    <span class="text-red-500 text-xs">Institute name must be between 2 and 150 characters.</span>
                                    }@else if (education.get('institute_name')?.hasError('trim')) {
                                    <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                    }
                                    
                                    @else if (education.get('institute_name')?.hasError('pattern')) {
                                    <span class="text-red-500 text-xs">Please enter a valid institute name.</span>
                                    }
                                    }
                                </label>


                            </div>
                            }

                            <div>
                                <button type="button" (click)="modifyEducation('add')"
                                    class="mt-3 w-full py-3 btn bg-white border-2 border-dashed border-gray-300">
                                    Add More Education
                                </button>
                            </div>
                        </div>

                        <div class="sticky -bottom-3 left-0 flex justify-end bg-white gap-x-3 mt-5 py-2">
                            @if (type == 'edit') {
                            <button type="button" class="btn rounded-full btn-sm px-5" (click)="currentTab='address'"
                                [disabled]="isreqSending">Back</button>
                            <button type="button" class="btn rounded-full btn-sm px-5" (click)="currentTab='experience'"
                                [disabled]="isreqSending">Next</button>
                            }
                            <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isreqSending">
                                @if (isreqSending) {
                                <i class="ri-loader-2-line animate-spin"></i>
                                }@else {
                                <span>Save</span>
                                }
                            </button>

                        </div>

                    </form>

                    <!-- education Details -->
                    <!-- work experience Details -->
                    <form [formGroup]="userWorkExperienceForm" (ngSubmit)="saveWorkExperienceDetails()"
                        *ngSwitchCase="'experience'">


                        <div formArrayName="work_experience" class="grid grid-cols-1 gap-3  divide-y ">
                            @for (work of workExperienceControls; track $index) {
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-3 pt-2" [formGroupName]="$index">

                                <div class="col-span-full flex items-center justify-between">
                                    <div>
                                        <p class="font-semibold underline capitalize">
                                            Experience {{ $index + 1 }}
                                        </p>


                                    </div>
                                    @if ($index > 0) {
                                    <button type="button" (click)="modifyExperience('remove', $index)"
                                        class="btn btn-sm rounded-full bg-red-100 text-red-500">
                                        <i class="ri-delete-bin-line"></i> Remove
                                    </button>
                                    }
                                </div>


                                <label class="form-control col-span-2 w-full">
                                    <div class="label">
                                        <span class="label-text req">Institute Name</span>
                                    </div>
                                    <input formControlName="institute" type="text" class="input input-bordered w-full"
                                        [ngClass]="{'error': work.get('institute')?.invalid && work.get('institute')?.touched}" />
                                    @if (work.get('institute')?.invalid && work.get('institute')?.touched) {
                                    @if (work.get('institute')?.hasError('required')) {
                                    <span class="text-red-500 text-xs">Institute name is required.</span>
                                    } @else if (work.get('institute')?.hasError('minlength') || work.get('institute')?.hasError('maxlength')) {
                                    <span class="text-red-500 text-xs">Institute name must be between 2 and 150 characters.</span>
                                    }@else if (work.get('institute')?.hasError('trim')) {
                                    <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                    }
                                    
                                    @else if (work.get('institute')?.hasError('pattern')) {
                                    <span class="text-red-500 text-xs">Please enter a valid institute name.</span>
                                    }
                                    }
                                </label>

                                <label class="form-control col-span-1 w-full">
                                    <div class="label">
                                        <span class="label-text req">Position</span>
                                    </div>
                                    <input formControlName="position" type="text" class="input input-bordered w-full"
                                        [ngClass]="{'error': work.get('position')?.invalid && work.get('position')?.touched}" />
                                    @if (work.get('position')?.invalid && work.get('position')?.touched) {
                                    @if (work.get('position')?.hasError('required')) {
                                    <span class="text-red-500 text-xs">Position is required.</span>
                                    } @else if (work.get('position')?.hasError('minlength') || work.get('position')?.hasError('maxlength')) {
                                    <span class="text-red-500 text-xs">Position must be between 2 and 100 characters.</span>
                                    }@else if (work.get('position')?.hasError('trim')) {
                                    <span class="text-red-500 text-xs">Please trim extra spaces.</span>
                                    }
                                     @else if (work.get('position')?.hasError('pattern')) {
                                    <span class="text-red-500 text-xs">Please enter a valid position.</span>
                                    }
                                    }
                                </label>

                                <label class="form-control col-span-1 w-full">
                                    <div class="label">
                                        <span class="label-text req">Duration</span>
                                    </div>
                                    <select formControlName="duration" class="select select-bordered w-full"
                                        [ngClass]="{'error': work.get('duration')?.invalid && work.get('duration')?.touched}">
                                        <option disabled selected>Choose Duration</option>
                                        <option value="1 month">1 month</option>
                                        <option value="3 months">3 months</option>
                                        <option value="6 months">6 months</option>
                                        <option value="1 year">1 year</option>
                                        <option value="2 years">2 years</option>
                                        <option value="3 years">3 years</option>
                                        <option value="4 years">4 years</option>
                                        <option value="5 years">5 years</option>
                                        <option value="6 years">6 years</option>
                                        <option value="7 years">7 years</option>
                                        <option value="8 years">8 years</option>
                                        <option value="9 years">9 years</option>
                                        <option value="10 years">10 years</option>
                                        <option value="10+ years">10+ years</option>
                                    </select>
                                    @if (work.get('duration')?.invalid && work.get('duration')?.touched) {
                                    @if (work.get('duration')?.hasError('required')) {
                                    <span class="text-red-500 text-xs">Duration is required.</span>
                                    } @else if (work.get('duration')?.hasError('minlength') || work.get('duration')?.hasError('maxlength')) {
                                    <span class="text-red-500 text-xs">Duration must be between 2 and 30 characters.</span>
                                    }
                                    }
                                </label>


                            </div>
                            }

                            <div>
                                <button type="button" (click)="modifyExperience('add')"
                                    class="mt-3 w-full py-3 btn bg-white border-2 border-dashed border-gray-300">
                                    Add More Experience
                                </button>
                            </div>

                        </div>
                        <div class="flex justify-end gap-2 mt-5 sticky -bottom-3 left-0 bg-white py-2">
                            @if (type == 'edit') {
                            <button type="button" class="btn rounded-full btn-sm px-5"
                                (click)="currentTab='education'" [disabled]="isreqSending">Back</button>
                            }
                            @if (type == 'edit' && userType == 'TEACHER') {
                            <button type="button" class="btn rounded-full btn-sm px-5"
                                (click)="currentTab='assign-course'" [disabled]="isreqSending">Next</button>
                            }
                            <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isreqSending">
                                @if (isreqSending) {
                                <i class="ri-loader-2-line animate-spin"></i>
                                }@else {
                                <span>Save</span>
                                }
                            </button>

                        </div>


                    </form>
                    <!-- work experience Details -->
                    @if (userType == 'TEACHER') {
                    <form [formGroup]="userAssignCourseForm" (ngSubmit)="saveAssignCourse()"
                        *ngSwitchCase="'assign-course'">

                        <div formArrayName="assign_courses" class="grid grid-cols-1 gap-3  divide-y ">

                            @for (i of assignCourseArray.controls; track $index) {
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-3 pt-2" [formGroupName]="$index">

                                <div class="col-span-full flex items-center justify-between">
                                    <div>
                                        <p class="font-semibold underline capitalize">
                                            Assign Course {{ $index + 1 }}
                                        </p>


                                    </div>
                                    @if ($index > 0) {
                                    <button type="button" (click)="modifyAssignCourse('remove', $index)"
                                        class="btn btn-sm rounded-full bg-red-100 text-red-500">
                                        <i class="ri-delete-bin-line"></i> Remove
                                    </button>
                                    }
                                </div>

                                <label class="form-control col-span-1 w-full ">
                                    <div class="label">
                                        <span class="label-text req">course</span>
                                    </div>
                                    <select formControlName="course" class="select select-bordered w-full " 
                                    [ngClass]="{'error': i.get('course')?.invalid && i.get('course')?.touched}" >

                                        <option disabled selected>Choose Department</option>
                                        @for (i of (courses$ | async)?.data || []; track $index) { 
                                        <option class="text-base" value="{{i?.id}}">{{i?.course_name}}</option>
                                        }
                                    </select>
                                    @if (i.get('course')?.invalid && i.get('course')?.touched) {
                                    <span class="text-red-500 text-xs">Course is required</span>
                                    }
                                </label>

                                <label class="form-control col-span-1 w-full ">
                                    <div class="label">
                                        <span class="label-text req">Departments</span>
                                    </div>
                                    <select formControlName="department" class="select select-bordered w-full "
                                    [ngClass]="{'error': i.get('department')?.invalid && i.get('department')?.touched}"
                                     (change)="onAssignCourseSelectChange($event, $index, 'department')">
                                        <option disabled selected>Choose Department</option>
                                        @for (i of departmentLists || []; track $index) {
                                        <option class="text-base" value="{{i?.id}}">{{i?.department_name}}</option>
                                        }
                                    </select>
                                    @if (i.get('department')?.invalid && i.get('department')?.touched) {
                                    <span class="text-red-500 text-xs">Department is required</span>
                                    }
                                </label>

                                <label class="form-control col-span-1 w-full ">
                                    <div class="label">
                                        <span class="label-text req">Class</span>
                                    </div>
                                    <select formControlName="class" class="select select-bordered w-full "
                                    [ngClass]="{'error': i.get('class')?.invalid && i.get('class')?.touched}"
                                        (change)="onAssignCourseSelectChange($event, $index, 'class')">
                                        <option disabled selected>Choose Department</option>
                                        @for (i of getAssignCourseOptions($index, 'class') || []; track $index) {
                                        <option class="text-base" value="{{i?.id}}">{{i?.class_name}}</option>
                                        }
                                    </select>
                                    @if (i.get('class')?.invalid && i.get('class')?.touched) {
                                    <span class="text-red-500 text-xs">Class is required</span>
                                    }
                                </label>

                                <label class="form-control col-span-1 w-full ">
                                    <div class="label">
                                        <span class="label-text req">Batch</span>
                                    </div>
                                    <select formControlName="batch" class="select select-bordered w-full"
                                    [ngClass]="{'error': i.get('batch')?.invalid && i.get('batch')?.touched}">
                                        <option disabled selected>Choose Department</option>
                                        @for (i of getAssignCourseOptions($index, 'batch') || []; track $index) {
                                        <option class="text-base" value="{{i?.id}}">{{i?.batch_name}}</option>
                                        }
                                    </select>
                                    @if (i.get('batch')?.invalid && i.get('batch')?.touched) {
                                    <span class="text-red-500 text-xs">Batch is required</span>
                                    }
                                </label>
                            </div>
                            }

                            <div>
                                <button type="button" (click)="modifyAssignCourse('add')"
                                    class="mt-3 w-full py-3 btn bg-white border-2 border-dashed border-gray-300">
                                    Assign More Courses
                                </button>
                            </div>

                        </div>

                        <div class="flex justify-end gap-2 mt-5 sticky -bottom-3 left-0 bg-white py-2">
                            @if (type == 'edit') {
                            <button type="button" class="btn rounded-full btn-sm px-5"
                                (click)="currentTab='experience'" [disabled]="isreqSending">Back</button>
                            }
                            <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isreqSending">
                                @if (isreqSending) {
                                <i class="ri-loader-2-line animate-spin"></i>
                                }@else {
                                <span>Save</span>
                                }
                            </button>
                        </div>


                    </form>
                    }

                </ng-container>
                } @placeholder {
                <app-loader></app-loader>
                }
            </div>

        </div>

    </div>
</dialog>